export default "__VITE_ASSET__48a67118__"